import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  FaDownload,
  FaFilePdf,
  FaVideo,
  FaBook,
  FaChartLine,
} from "react-icons/fa";
import "./Pages.css";

const Resources = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const resources = [
    {
      title: "Growth Strategy Guide",
      description:
        "A comprehensive guide to scaling your business with data-driven strategies.",
      icon: <FaFilePdf />,
      type: "PDF",
      size: "2.4 MB",
      url: "#",
    },
    {
      title: "Digital Marketing Playbook",
      description:
        "Step-by-step guide to effective digital marketing campaigns.",
      icon: <FaBook />,
      type: "eBook",
      size: "9.4kb",
      url: "../../downloads/Target confernce month wise 2026.xlsx",
    },
    {
      title: "Data Analytics Masterclass",
      description: "Video series on leveraging data for business decisions.",
      icon: <FaVideo />,
      type: "Video",
      duration: "45 min",
      url: "#",
    },
    {
      title: "ROI Calculator Template",
      description: "Excel template to calculate marketing and business ROI.",
      icon: <FaChartLine />,
      type: "Template",
      size: "1.2 MB",
      url: "#",
    },
  ];

  return (
    <main>
      <Helmet>
        <title>Resources | Seagull Partners</title>
        <meta
          name="description"
          content="Browse Seagull Partners resources for B2B growth—insights, guides, and updates on data intelligence, marketing, and strategy to drive results you can use."
        />
      </Helmet>

      <section className="page-hero">
        <div className="container">
          <h1 className="page-hero-title">Free Resources & Guides</h1>
          <p className="page-hero-subtitle">
            Download our free resources to help your business grow smarter,
            faster, and more efficiently.
          </p>
        </div>
      </section>

      <section className="section resources-section">
        <div className="container">
          <div className="resources-intro">
            <h2 className="section-title">Learn, Grow, Succeed</h2>
            <p className="section-subtitle">
              Access our collection of free resources designed to help
              businesses at every growth stage.
            </p>
          </div>

          <div className="resources-grid">
            {resources.map((resource, index) => (
              <div key={index} className="resource-card">
                <div className="resource-icon">{resource.icon}</div>
                <div className="resource-content">
                  <div className="resource-header">
                    <h3>{resource.title}</h3>
                    <span className="resource-type">{resource.type}</span>
                  </div>
                  <p className="resource-description">{resource.description}</p>
                  <div className="resource-meta">
                    <span className="resource-size">
                      {resource.size || resource.duration}
                    </span>
                  </div>
                   <a
                          href={resource.url}
                          download
                          className="btn resource-download-btn"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FaDownload className="btn-icon" />
                          Download Now
                   </a>

                </div>
              </div>
            ))}
          </div>

          <div className="resources-cta">
            <h3>Need Personalized Guidance?</h3>
            <p>
              Book a free consultation with our experts for tailored advice.
            </p>
            <Link to="/contact" className="btn cta-btn">
              Schedule Free Consultation
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Resources;
